import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Layout from "../layout/Layout";
import "./Dashboard.css";

// Images
import LogoIcon from "../assets/images/SliderLogo.png";
import stateImg from "../assets/images/s1.png";
import Subscribed1 from "../assets/images/s2.png";
import Subscribed2 from "../assets/images/s3.png";
import FavState1 from "../assets/images/s4.png";
import FavState2 from "../assets/images/s5.png";
import FavState3 from "../assets/images/s8.png";
import FavState4 from "../assets/images/s9.png";
import otherState1 from "../assets/images/s6.png";
import otherState2 from "../assets/images/s7.png";
import otherState3 from "../assets/images/s7.png";
import otherState4 from "../assets/images/s6.png";
function States() {
  return (
    <Layout>
      <div className="content-container states-grid">
        {/* My States Section */}
        <Row className="g-4 align-items-start dashboard-states mt-0">
         

          {/* My States */}
          <Col lg={12}>
            <div className="state-heading d-flex justify-content-between align-items-center">
              <h6 className="states-title fw-bold mb-0">My States</h6>
               </div>
            <div className="state-card myState">
              {/* Background image */}
              <img src={stateImg} className="state-bg" alt="" />

              {/* Badge */}
              <div className="state-badge">
                <img src={LogoIcon} alt="Badge" />
              </div>
            {/* Content */}
              <div className="state-content">
                <h5>Assam</h5>
                <p>(Dispur)</p>
              </div>
            </div>
          </Col>

          {/* Subscribed States */}
          <Col lg={12}>
             <div className="state-heading d-flex justify-content-between align-items-center">
                <h6 className="states-title fw-bold mb-0">Subscribed States</h6>
            </div>
            <Row className="g-3">
              <Col xs={6}>
                <div className="state-card">
                  {/* Background image */}
                  <img src={Subscribed1} className="state-bg" alt="Assam" />

                  {/* Badge */}
                  <div className="state-badge">
                    <img src={LogoIcon} alt="Badge" />
                  </div>

                  {/* Tick */}
                  <div className="state-tick">
                    <i className="fa-solid fa-check"></i>
                  </div>

                  {/* Content */}
                  <div className="state-content">
                    <h5>Assam</h5>
                    <p>(Dispur)</p>
                  </div>
                </div>
              </Col>

              <Col xs={12}>
                <div className="state-card">
                  {/* Background image */}
                  <img src={Subscribed2} className="state-bg" alt="" />

                  {/* Badge */}
                  <div className="state-badge">
                    <img src={LogoIcon} alt="Badge" />
                  </div>

                  {/* Tick */}
                  <div className="state-tick">
                    <i className="fa-solid fa-check"></i>
                  </div>

                  {/* Content */}
                  <div className="state-content">
                    <h5>Assam</h5>
                    <p>(Dispur)</p>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
        {/* End My States Section*/}

        {/* Favorite  States Section */}
        <Row className="g-4 align-items-start dashboard-states">
          {/* Favorite States */}
          <Col lg={12}>
            <div className="state-heading d-flex justify-content-between align-items-center">
              <h6 className="states-title fw-bold mb-0">Favorite  States</h6>
              <div className="addState fw-bold">
                 <i className="fa-solid fa-plus me-1"></i>   Add State
              </div>
              </div>
            <Row className="g-3 mb-3">
              <Col xs={6}>
                <div className="state-card">
                  {/* Background image */}
                  <img src={FavState1} className="state-bg" alt="" />

                  {/* Badge */}
                  <div className="state-badge">
                    <img src={LogoIcon} alt="Badge" />
                  </div>

                  {/* Tick */}
                  <div className="state-tick">
                    <i className="fa-solid fa-check"></i>
                  </div>

                  {/* Content */}
                  <div className="state-content">
                    <h5>Assam</h5>
                    <p>(Dispur)</p>
                  </div>
                </div>
              </Col>

              <Col xs={6}>
                <div className="state-card">
                  {/* Background image */}
                  <img src={FavState2} className="state-bg" alt="" />

                  {/* Badge */}
                  <div className="state-badge">
                    <img src={LogoIcon} alt="Badge" />
                  </div>

                  {/* Tick */}
                  <div className="state-tick">
                    <i className="fa-solid fa-check"></i>
                  </div>

                  {/* Content */}
                  <div className="state-content">
                    <h5>Assam</h5>
                    <p>(Dispur)</p>
                  </div>
                </div>
              </Col>
              <Col xs={6}>
                <div className="state-card">
                  {/* Background image */}
                  <img src={FavState3} className="state-bg" alt="" />

                  {/* Badge */}
                  <div className="state-badge">
                    <img src={LogoIcon} alt="Badge" />
                  </div>

                  {/* Tick */}
                  <div className="state-tick">
                    <i className="fa-solid fa-check"></i>
                  </div>

                  {/* Content */}
                  <div className="state-content">
                    <h5>Assam</h5>
                    <p>(Dispur)</p>
                  </div>
                </div>
              </Col>
              <Col xs={6}>
                <div className="state-card">
                  {/* Background image */}
                  <img src={FavState4} className="state-bg" alt="" />

                  {/* Badge */}
                  <div className="state-badge">
                    <img src={LogoIcon} alt="Badge" />
                  </div>

                  {/* Tick */}
                  <div className="state-tick">
                    <i className="fa-solid fa-check"></i>
                  </div>

                  {/* Content */}
                  <div className="state-content">
                    <h5>Assam</h5>
                    <p>(Dispur)</p>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>

          {/* Other States */}
          <Col lg={12}>
           <div className="state-heading d-flex justify-content-between align-items-center">
                <h6 className="states-title fw-bold mb-0">Other States</h6>
            </div>
             <Row className="g-3">
              <Col xs={6}>
                <div className="state-card">
                  {/* Background image */}
                  <img src={otherState1} className="state-bg" alt="" />

                  {/* Badge */}
                  <div className="state-badge">
                    <img src={LogoIcon} alt="Badge" />
                  </div>

                  {/* Tick */}
                  <div className="state-tick">
                    <i className="fa-solid fa-check"></i>
                  </div>

                  {/* Content */}
                  <div className="state-content">
                    <h5>Assam</h5>
                    <p>(Dispur)</p>
                  </div>
                </div>
              </Col>

              <Col xs={12}>
                <div className="state-card">
                  {/* Background image */}
                  <img src={otherState2} className="state-bg" alt="" />

                  {/* Badge */}
                  <div className="state-badge">
                    <img src={LogoIcon} alt="Badge" />
                  </div>

                  {/* Tick */}
                  <div className="state-tick">
                    <i className="fa-solid fa-check"></i>
                  </div>

                  {/* Content */}
                  <div className="state-content">
                    <h5>Assam</h5>
                    <p>(Dispur)</p>
                  </div>
                </div>
              </Col>

              <Col xs={12}>
                <div className="state-card">
                  {/* Background image */}
                  <img src={otherState3} className="state-bg" alt="" />

                  {/* Badge */}
                  <div className="state-badge">
                    <img src={LogoIcon} alt="Badge" />
                  </div>

                  {/* Tick */}
                  <div className="state-tick">
                    <i className="fa-solid fa-check"></i>
                  </div>

                  {/* Content */}
                  <div className="state-content">
                    <h5>Assam</h5>
                    <p>(Dispur)</p>
                  </div>
                </div>
              </Col>

              <Col xs={12}>
                <div className="state-card">
                  {/* Background image */}
                  <img src={otherState4} className="state-bg" alt="" />

                  {/* Badge */}
                  <div className="state-badge">
                    <img src={LogoIcon} alt="Badge" />
                  </div>

                  {/* Tick */}
                  <div className="state-tick">
                    <i className="fa-solid fa-check"></i>
                  </div>

                  {/* Content */}
                  <div className="state-content">
                    <h5>Assam</h5>
                    <p>(Dispur)</p>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
        {/* End Favorite States Section*/}
      </div>

    
     
    </Layout>
  );
}

export default States;

